import { network } from 'services/network';
import { useQuery } from 'react-query';

const getPasswordPatternData = (params) => {
    const url = `admin/bo/getPasswordPattern?email=${params.email}`;
    return network
        .post(url)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

const useQueryPasswordPatternData = (params) => {
    return useQuery(['passwordPatternData ', params], () => getPasswordPatternData(params), {
        enabled: Boolean(params?.email),
    });
};

export { useQueryPasswordPatternData };
